import cn from 'classnames';
import Markdown from 'markdown-to-jsx';
import { useEffect, useState } from 'react';
import { Button } from 'ui';
import s from './Faq.module.scss';
type FaqProps = {
  faqTitle: string;
  faqContent: any;
  viewHeight?: number;
};
export const Faq = ({ faqTitle, faqContent, viewHeight }: FaqProps) => {
  const [isViewMore, setIsViewMore] = useState(faqContent.length > viewHeight);
  const showViewMore = faqContent.length > viewHeight;
  useEffect(()=>{
    if(faqContent.length > viewHeight){
      setIsViewMore(true);
    }
  },[faqContent,viewHeight])
  return (
    <div className={s.root}>
      <Markdown className={s.faq_title}>{faqTitle}</Markdown>
      <div className={s.content_wrapper}>
        <Markdown
          className={cn(s.content, {
            [s.hide]: isViewMore,
          })}
          style={
            isViewMore
              ? {
                  height: `${viewHeight}px`,
                }
              : {}
          }
        >
          {faqContent}
        </Markdown>
        {isViewMore && <div className={s.opacity_box} />}
      </div>
      {showViewMore && (
        <div className={s.btn}>
          <Button
            label={`View ${isViewMore ? 'more' : 'less'}`}
            variant="ButtonGhostDefault"
            onClick={() => setIsViewMore((state) => !state)}
          />
        </div>
      )}
    </div>
  );
};
